(function () {
  if (customElements.get('krew-music')) return;
  class KrewMusic extends HTMLElement {
    connectedCallback() {
      this.releases = Array.from(this.querySelectorAll('[data-release]'));
      this.player = this.querySelector('[data-music-player]');
      this.toggle = this.querySelector('[data-toggle-tracklist]');
      this.rail = this.querySelector('[data-album-rail]');
      this.controls = this.querySelector('[data-carousel-controls]');
      this.onRailScroll = this.scheduleRailUpdate.bind(this);
      this.onClick = this.handleClick.bind(this);
      this.onBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      if (this.rail) {
        this.rail.addEventListener('scroll', this.onRailScroll, { passive: true });
        this.railObserver = new ResizeObserver(this.onRailScroll);
        this.railObserver.observe(this.rail);
        this.updateRail();
      }
      if (this.releases.length) this.selectRelease(this.releases[0], false);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.rail) this.rail.removeEventListener('scroll', this.onRailScroll);
      if (this.railObserver) this.railObserver.disconnect();
      cancelAnimationFrame(this.railFrame);
    }
    scheduleRailUpdate() {
      cancelAnimationFrame(this.railFrame);
      this.railFrame = requestAnimationFrame(() => this.updateRail());
    }
    updateRail() {
      if (!this.rail || !this.controls) return;
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      this.controls.hidden = max < 2;
      this.querySelector('[data-album-previous]').disabled = this.rail.scrollLeft < 2;
      this.querySelector('[data-album-next]').disabled = this.rail.scrollLeft >= max - 2;
      const step = this.releases.length > 1 ? this.releases[1].offsetLeft - this.releases[0].offsetLeft : 1;
      const index = Math.max(0, Math.min(this.releases.length - 1, Math.round(this.rail.scrollLeft / step)));
      this.querySelector('[data-carousel-position]').textContent = String(index + 1).padStart(2, '0') + ' / ' + String(this.releases.length).padStart(2, '0');
    }
    moveRail(direction) {
      if (!this.rail || this.releases.length < 2) return;
      const step = this.releases[1].offsetLeft - this.releases[0].offsetLeft;
      this.rail.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    spotifySource(value) {
      try {
        const url = new URL(value);
        if (url.hostname !== 'open.spotify.com' || url.protocol !== 'https:') return null;
        const match = url.pathname.match(/^\/(?:intl-[^/]+\/)?(?:embed\/)?(album|artist|playlist|track)\/([a-zA-Z0-9]+)\/?$/);
        if (!match) return null;
        return { embed: 'https://open.spotify.com/embed/' + match[1] + '/' + match[2] + '?theme=0', link: 'https://open.spotify.com/' + match[1] + '/' + match[2] };
      } catch (_) { return null; }
    }
    selectRelease(release, announce) {
      const button = release.querySelector('[data-select-release]');
      if (!button) return;
      const source = this.spotifySource(button.dataset.spotifyUrl);
      this.releases.forEach(item => {
        const selected = item === release;
        item.classList.toggle('is-selected', selected);
        item.querySelector('[data-select-release]').setAttribute('aria-pressed', String(selected));
      });
      const title = this.querySelector('[data-selected-title]');
      const description = this.querySelector('[data-selected-description]');
      if (title) title.textContent = button.dataset.title;
      if (description) description.textContent = button.dataset.description;
      const link = this.querySelector('[data-spotify-link]');
      if (link) {
        link.hidden = !source;
        if (source) link.href = source.link;
      }
      if (this.player) {
        this.player.hidden = !source;
        this.querySelector('[data-player-unavailable]').hidden = !!source;
        this.toggle.hidden = !source;
        if (source) {
          this.player.title = button.dataset.title + ' on Spotify';
          if (this.player.getAttribute('src') !== source.embed) this.player.src = source.embed;
        } else {
          this.player.removeAttribute('src');
        }
      }
      if (announce) this.querySelector('[data-selection-status]').textContent = button.dataset.title + ' selected.';
    }
    handleClick(event) {
      if (event.target.closest('[data-album-previous]')) this.moveRail(-1);
      if (event.target.closest('[data-album-next]')) this.moveRail(1);
      const select = event.target.closest('[data-select-release]');
      if (select && this.contains(select)) this.selectRelease(select.closest('[data-release]'), true);
      const toggle = event.target.closest('[data-toggle-tracklist]');
      if (toggle && this.player) {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = (expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel) + (expanded ? ' −' : ' +');
        this.player.height = expanded ? '352' : '152';
      }
    }
    handleBlockSelect(event) {
      if (event.detail.sectionId && String(event.detail.sectionId) !== this.dataset.sectionId) return;
      const release = this.releases.find(item => item.dataset.blockId === String(event.detail.blockId));
      if (release) {
        this.selectRelease(release, false);
        if (this.rail && this.rail.scrollWidth > this.rail.clientWidth) {
          this.rail.scrollTo({ left: release.offsetLeft - this.releases[0].offsetLeft, behavior: 'auto' });
        }
      }
    }
  }
  customElements.define('krew-music', KrewMusic);
})();
